"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;
const json2csv_1 = require("json2csv");
const igt_name_map_1 = require("../utils/igt-name-map");
const issue_mapper_1 = require("../utils/issue-mapper");
function default_1(issues, options = { delimiter: ',' }) {
    const fields = [
        {
            label: 'Page URL',
            value: 'testUrl'
        },
        {
            label: 'Page Title',
            value: 'testPageTitle'
        },
        {
            label: 'Outcome',
            value: ''
        },
        {
            label: 'Impact',
            value: (row) => (row.isNeedsReview ? '' : row.impact)
        },
        {
            label: 'Code Snippet',
            value: 'source'
        },
        {
            label: 'Selector',
            value: 'selector'
        },
        {
            label: 'Remediation',
            value: 'summary'
        },
        {
            label: 'Manual',
            value: (row) => (row.isManual ? 'Yes' : 'No')
        },
        {
            label: 'Rule ID',
            value: 'rule'
        },
        {
            label: 'Help',
            value: 'helpText'
        },
        {
            label: 'Description',
            value: 'description'
        },
        {
            label: 'Help URL',
            value: 'helpUrl'
        },
        {
            label: 'Standard',
            value: '' // see: https://github.com/dequelabs/axe-extension/issues/3419
        },
        {
            label: 'WCAG 2 Success Criteria',
            value: '' // see: https://github.com/dequelabs/axe-extension/issues/3419
        },
        {
            label: 'Section 508 Paragraph',
            value: ''
        },
        {
            label: 'Tags',
            value: (row) => (0, issue_mapper_1.getIssueTags)(row).join(',')
        },
        {
            label: 'Date',
            value: 'createdAt'
        },
        {
            // Do not capitalize "axe-core" in column header that downstream tools may parse by name.
            label: 'axe-core',
            value: 'axeVersion'
        },
        {
            label: 'Needs Review',
            value: (row) => (row.isNeedsReview ? 'Yes' : 'No')
        },
        {
            label: 'IGT',
            value: (row) => (0, igt_name_map_1.getIgtName)(row.igtTool)
        },
        {
            label: 'Found By',
            value: 'foundBy'
        },
        {
            label: 'Test Title',
            value: 'testName'
        },
        {
            label: 'Share URL',
            value: 'shareURL'
        }
    ];
    return (0, json2csv_1.parseAsync)(issues, {
        delimiter: options.delimiter,
        excelStrings: false,
        fields: fields
    });
}
//# sourceMappingURL=csv-axe-reports.js.map